import React from "react";

/**
 * Ventures International brand assets — used across login, sidebar, dashboard, etc.
 * Keep the logo file at /app/frontend/public/ventures-logo.png (deployed as
 * REACT_APP_BACKEND_URL host root /ventures-logo.png during local dev too).
 */
export const SOFTWARE_NAME = "Ventures International Service Management";
export const COMPANY_NAME = "Ventures International";
export const SOFTWARE_TAGLINE = "Service Management";

// Use process.env.PUBLIC_URL so the file resolves under any deployment base path.
const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/ventures-logo.png`;

export function BrandLogo({ size = 36, className = "", testId = "brand-logo" }) {
  // The source PNG is a black-and-gold mark on a black square. We render it on
  // a black rounded tile so it never gets stretched or recoloured — only resized.
  return (
    <div
      className={`rounded-md bg-black flex items-center justify-center overflow-hidden ${className}`}
      style={{ width: size, height: size }}
      data-testid={testId}
    >
      <img
        src={LOGO_SRC}
        alt="Ventures International"
        className="w-full h-full object-contain"
        draggable={false}
      />
    </div>
  );
}
